import * as Yup from 'yup';

const consent = Yup.bool()
    .test('consent', 'You must agree with the terms and conditions.', (value) => value === true)
    .required('You must agree with the terms and conditions');

export default consent;
